// loadWordCloudSvg.js
// Fetches the raw wordcloud.svg markup (served from public/, see the Phase 2
// report for why it can't be a JS import) and caches it in module scope so
// re-opening the Safe activity doesn't re-download 1.78 MB every time.
export const WORDCLOUD_URL = `${process.env.PUBLIC_URL}/escape-to-inner-peace/svg/wordcloud.svg`;

let cachedMarkup = null;
let inFlightPromise = null;

export function loadWordCloudSvg() {
  if (cachedMarkup) return Promise.resolve(cachedMarkup);
  if (inFlightPromise) return inFlightPromise;

  inFlightPromise = fetch(WORDCLOUD_URL)
    .then((res) => res.text())
    .then((text) => {
      // Strip the XML prolog — unnecessary (and non-standard) inside an
      // HTML-parsed innerHTML target.
      cachedMarkup = text.replace(/^<\?xml[^>]*\?>/, '');
      inFlightPromise = null;
      return cachedMarkup;
    });

  return inFlightPromise;
}
